import React from 'react'

//* Assets
import wp_assets from 'assets/wordpress.json';

//* Translations
import { TRANSLATIONS } from 'pages/FindYourPhone/utilities';
import { getTranslation } from 'translations';

//* Components
import Button from 'components/Button/Button';

//* Hooks
import useResponsiveJSX from 'hooks/useResponsiveJSX';

//* Styles
import styles from './Section2.module.scss';

const Section2 = () => {

    const bp = useResponsiveJSX();

    const LANG = document.documentElement.lang.substring(0, 2).toLowerCase();

  function gotoHIW(){
    const urls_by_lang = {
      "en": "how-it-works",
      "it": "come-funziona",
      "de": "filo-wie-es-funktioniert",
      "es": "filo-how-it-works",
      "fr": "filo-how-it-works",
    }

    window.location.href = `https://filotrack.com/${LANG === "en" ? urls_by_lang[LANG] : `${LANG}/${urls_by_lang[LANG]}`}`
  }

  return (
    <section className={`${styles["section-2"]} ${bp < 3 ? styles["section-2-sm"] : styles["section-2-xl"]}`}>
        <div className={`${styles["caption"]} ${bp < 3 ? styles["caption-sm"] : styles["caption-xl"]}`}>
            <h3 className={styles["title"]}>{getTranslation(TRANSLATIONS, LANG, "section2-title")}</h3>
            <p className={styles["subtitle"]}>{getTranslation(TRANSLATIONS, LANG, "section2-subtitle")}</p>
            <p className={styles["text1"]}>{getTranslation(TRANSLATIONS, LANG, "section2-text1")}</p>
            <Button
              handlers={{onClick: gotoHIW}}
              variant="secondary"
            >
              {getTranslation(TRANSLATIONS, LANG, "how-it-works")}
            </Button>
        </div>
            <img src={wp_assets["find-your-phone"].section2[LANG]} alt="" className={`${styles["section2-img"]} ${bp < 3 ? styles["section2-img-sm"] : styles["section2-img-xl"]}`} />
    </section>
  )
}

export default Section2